import React, { Component } from "react";

import Desktop from "../../components/Desktop";
import Mobile from "../../components/Mobile";
import { connect } from "react-redux";
import { getSettings } from "../../services/settings/actions";
import { getAllLanguages } from "../../services/languages/actions";
import { isSafari, hasSafariIframeIssues, setSafariIframeIssues } from "../../utils/userAgentProtection";

class App extends Component {
	state = {
		isSafari: false,
		forceMobile: false
	};

	componentDidMount() {
		console.log("App component mounting...");
		console.log("Window width:", window.innerWidth);
		console.log("Window height:", window.innerHeight);
		console.log("User agent:", navigator.userAgent);
		
		// Detect Safari browser
		const safariDetected = isSafari();
		console.log("Safari detected:", safariDetected);
		this.setState({ isSafari: safariDetected });

		// Check if user has previously experienced issues on Safari
		const safariIssues = hasSafariIframeIssues();
		console.log("Safari issues detected:", safariIssues);
		if (safariDetected && safariIssues) {
			console.log("Forcing mobile view due to Safari issues");
			this.setState({ forceMobile: true });
		}

		// Check URL parameters for mobile/iframe requests
		this.checkUrlParameters();

		// Request location permission on app load
		this.requestLocationPermission();

		console.log("Loading settings and languages...");
		this.props.getSettings();
		this.props.getAllLanguages();
	}

	checkUrlParameters = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const isMobileRequest = urlParams.get('mobile') === 'true';
		const isIframeRequest = urlParams.get('iframe') === 'true';
		
		// Force mobile view if mobile parameter is present or if it's an iframe request
		if (isMobileRequest || isIframeRequest) {
			console.log('Forcing mobile view due to URL parameters');
			this.setState({ forceMobile: true });
		}
	};

	requestLocationPermission = () => {
		// Request location permission proactively
		if ("geolocation" in navigator) {
			try {
				// Show location permission explanation for iOS users
				const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
				if (isIOS && !localStorage.getItem("locationPermissionExplained")) {
					// For iOS, we need to be more explicit about location usage
					console.log("iOS device detected - location permission will be requested for food delivery services");
					localStorage.setItem("locationPermissionExplained", "true");
				}

				if ("permissions" in navigator && navigator.permissions.query) {
					navigator.permissions
						.query({ name: "geolocation" })
						.then((result) => {
							console.log("Location permission status:", result.state);
							if (result.state === "prompt") {
								// Request permission with better error handling for iOS
								navigator.geolocation.getCurrentPosition(
									(position) => {
										console.log("Location permission granted");
										localStorage.setItem("locationPermissionGranted", "true");
									},
									(error) => {
										console.log("Location permission denied:", error);
										localStorage.setItem("locationPermissionGranted", "false");
										// Provide helpful message for iOS users
										if (isIOS) {
											console.log("Location access is needed to find nearby restaurants and provide delivery services. Please enable location access in your device settings.");
										}
									},
									{ 
										timeout: 10000, // Increased timeout for iOS
										enableHighAccuracy: false,
										maximumAge: 300000 // 5 minutes cache
									}
								);
							} else if (result.state === "granted") {
								localStorage.setItem("locationPermissionGranted", "true");
							} else {
								localStorage.setItem("locationPermissionGranted", "false");
							}
						})
						.catch((error) => {
							console.log("Error checking location permission:", error);
						});
				} else {
					// Fallback for browsers that don't support permissions API
					navigator.geolocation.getCurrentPosition(
						(position) => {
							console.log("Location permission granted (fallback)");
							localStorage.setItem("locationPermissionGranted", "true");
						},
						(error) => {
							console.log("Location permission denied (fallback):", error);
							localStorage.setItem("locationPermissionGranted", "false");
							// Provide helpful message for iOS users
							if (isIOS) {
								console.log("Location access is needed to find nearby restaurants and provide delivery services. Please enable location access in your device settings.");
							}
						},
						{ 
							timeout: 10000, // Increased timeout for iOS
							enableHighAccuracy: false,
							maximumAge: 300000 // 5 minutes cache
						}
					);
				}
			} catch (error) {
				console.log("Error requesting location permission:", error);
			}
		}
	};

	handleSafariFallback = () => {
		setSafariIframeIssues(true);
		this.setState({ forceMobile: true });
	};

	// Detect if device is iPad/tablet
	isTablet = () => {
		const userAgent = navigator.userAgent.toLowerCase();
		const isIPad = /ipad/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
		const isTablet = /tablet/.test(userAgent) || /android/.test(userAgent) && /mobile/.test(userAgent) === false;
		const screenWidth = window.innerWidth;
		const screenHeight = window.innerHeight;
		
		// Check for iPad/tablet characteristics
		return isIPad || isTablet || (screenWidth >= 768 && screenWidth <= 1024) || (screenHeight >= 768 && screenHeight <= 1024);
	};

	render() {
		const { isSafari, forceMobile } = this.state;
		const isTablet = this.isTablet();
		
		// Show mobile interface for tablets/iPads or screens <= 768px
		const shouldUseMobile = window.innerWidth <= 768 || forceMobile || isTablet;
		
		console.log("App render - shouldUseMobile:", shouldUseMobile);
		console.log("App render - isTablet:", isTablet);
		console.log("App render - forceMobile:", forceMobile);
		console.log("App render - window.innerWidth:", window.innerWidth);

		return (
			<React.Fragment>
				{shouldUseMobile ? (
					<Mobile languages={this.props.languages} />
				) : (
					<Desktop 
						languages={this.props.languages} 
						isSafari={isSafari}
						onSafariFallback={this.handleSafariFallback}
					/>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	settings: state.settings.settings,
	user: state.user.user,
	notification_token: state.notification_token.notification_token,
	languages: state.languages.languages,
});

export default connect(
	mapStateToProps,
	{ getSettings, getAllLanguages }
)(App);
